import React, { useEffect } from "react";
import ActivityIcon from "@mui/icons-material/MessageOutlined";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "@mui/material/Avatar";
import {
  ActionContainer,
  ActionWrapper,
  CommentTitle,
  Text,
  Date,
  CommentArea,
  Container,
  HeadWrapper,
  LoadingBox,
  HeadTitle,
  Wrapper,
} from "./styled";
import moment from "moment";
import "moment/locale/vi";
import { activityUpdate } from "../../../../../../Services/boardService";
import CardLoadingSvg from "../../../../../../Images/cardLoading.svg";

const ActivitySection = () => {
  const board = useSelector((state) => state.board);
  const dispatch = useDispatch();
  useEffect(() => {
    activityUpdate(board.id, dispatch);
  }, [board.id, dispatch]);

  const Comment = (props) => {
    return (
      <ActionContainer>
        {props?.image ? (
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: props.color,
              fontSize: "0.875rem",
              fontWeight: "800",
            }}
            src={props.image.url}
            alt="Avatar"
          />
        ) : (
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: props.color,
              fontSize: "0.875rem",
              fontWeight: "800",
            }}
          >
            {props.name[0].toUpperCase()}
          </Avatar>
        )}
        <ActionWrapper>
          <CommentTitle>
            <Text>
              <b style={{ fontSize: "0.875rem" }}>{props.name}</b> trên{" "}
              {props.cardTitle}
            </Text>
            <Date>{moment(props.date).locale("vi").fromNow()}</Date>
          </CommentTitle>
          <CommentArea>{props.action}</CommentArea>
        </ActionWrapper>
      </ActionContainer>
    );
  };

  const Action = (props) => {
    return (
      <ActionContainer>
        {props?.image ? (
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: props.color,
              fontSize: "0.875rem",
              fontWeight: "800",
            }}
            src={props.image.url}
            alt="Avatar"
          />
        ) : (
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: props.color,
              fontSize: "0.875rem",
              fontWeight: "800",
            }}
          >
            {props.name?.toUpperCase()}
          </Avatar>
        )}
        <ActionWrapper>
          <Text>
            <b style={{ fontSize: "0.875rem" }}>{props.name}</b> {props.action}
          </Text>
          <Date>{moment(props.date).locale("vi").fromNow()}</Date>
        </ActionWrapper>
      </ActionContainer>
    );
  };

  return (
    <Container>
      <HeadWrapper>
        <ActivityIcon fontSize="small" />
        <HeadTitle>Hoạt động</HeadTitle>
      </HeadWrapper>
      <Wrapper>
        {board.activityLoading ? (
          <LoadingBox image={CardLoadingSvg} />
        ) : (
          board.activity.map((act) => {
            return act.actionType === "action" ? (
              <Action key={act._id} {...act} />
            ) : (
              <Comment key={act._id} {...act} />
            );
          })
        )}
      </Wrapper>
    </Container>
  );
};

export default ActivitySection;
